import React from 'react';
import { Button } from 'ui-toolkit/index';
import { eClientContactActionType } from '../../types/contacts/eClientContactActionType';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faUserCheck, faUserSlash } from '@fortawesome/pro-regular-svg-icons';
import { IPresentationLenderContactData } from '../../types/contacts/ILenderContact';
import { IPresentationClientUserData } from '../../types/clients';

interface IGetUserStatusButtonProps {
  user: IPresentationClientUserData | IPresentationLenderContactData;
  setContactAction: (type: eClientContactActionType) => void;
  onEditContact: () => void;
}

export const GetContactActionButton: React.FC<IGetUserStatusButtonProps> = ({
  user,
  setContactAction,
  onEditContact,
}) => {
  return (
    <>
      {user.active ? (
        <Button
          intent={'danger'}
          title={'Deactivate User'}
          onClick={() => setContactAction(eClientContactActionType.Deactivate)}
        >
          <FontAwesomeIcon icon={faUserSlash} />
        </Button>
      ) : (
        <Button
          title={'Activate User'}
          intent={'ghost'}
          onClick={() => setContactAction(eClientContactActionType.Activate)}
        >
          <FontAwesomeIcon icon={faUserCheck} />
        </Button>
      )}
      <Button intent={'ghost'} title={'Edit User'} onClick={() => onEditContact()}>
        <FontAwesomeIcon icon={faEdit} />
      </Button>
    </>
  );
};
